import { getUserCachedData } from './UserAuthorization'

export const isAdmin = () => {
  const userCachedData = getUserCachedData()
  return !!userCachedData?.admin
}

export const isSuperAdmin = () => {
  const userCachedData = getUserCachedData()
  return !!userCachedData?.super_admin
}
